import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Hero from "../components/Hero";
import Services from "../components/Services";
import BookingModal from "../components/BookingModal";
import StaffList from "../components/StaffList";
import MoreService from "../components/MoreService";
import PriseList from "../components/PriseList";
import CustomerReview from "../components/CustomerReview";
import Contact from "../components/Contact";
import BrandList from "../components/BrandList";
import ProductList from "../components/ProductList";
import { Product } from "../types/product";
import { parseCsvFile } from "../utils/parseCsv";
import { slugify } from "../utils/generalFunction";
import { getAllBlogPosts } from "../utils/firebaseBlogUtils";
import { useBlogStore } from "../store/blogStore";
import { BlogPostCard } from "../components/blog";

const Home = () => {
  const [openBooking, setOpenBooking] = useState(false);
  const [serviceNameSelected, setServiceNameSelected] = useState("");
  const [featuredProducts, setFeaturedProducts] = useState<Product[]>([]);
  const { posts } = useBlogStore();
  const handleOpenBooking = (serviceName: string) => {
    setServiceNameSelected(serviceName);
    setOpenBooking(true);
  };
  const handleCloseBooking = () => setOpenBooking(false);

  useEffect(() => {
    parseCsvFile("/data/fpdl.csv").then((featuredProducts) => {
      setFeaturedProducts(featuredProducts);
    });
  }, []);

  return (
    <Box className="bg-primary_light_gray">
      <Grid container spacing={3} className="p-3 md:p-10 ">
        {posts.slice(0, 3).map((post, index) => (
          <BlogPostCard key={post.id} post={post} index={index} />
        ))}
      </Grid>
      <BrandList />
      <ProductList
        featuredProducts={featuredProducts.filter(
          (item) =>
            slugify(item.productCategory ? item.productCategory : "") ===
            "may-lanh-treo-tuong"
        )}
        title={{
          name: "MÁY LẠNH TREO TƯỜNG",
          link: "/products?category=may-lanh-treo-tuong",
        }}
        categories={[
          "Nagakawa",
          "Hisense",
          "Akino",
          "Comfee",
          "Sumikura",
          "Midea",
          "Casper",
          "Funiki",
          "Reetech",
          "HIKAWA",
          "Aqua",
          "Alaska",
          "Hitachi",
          "Airwell",
          "Sharp",
          "Gree",
          "Mitsubishi Heavy",
          "Samsung",
          "Carrier",
          "General",
          "Mitsubishi Electric",
          "LG",
          "Daikin",
          "Toshiba",
          "Panasonic",
          "Fujitsu",
          "Electrolux",
          "Dairry",
          "Fujiaire",
        ]}
        bannerImage={
          "https://sieuthimaylanh.com/uploads/product/advertise/thumbs/may_lanh_treo_tuong_inverter-1600x400.jpg"
        }
      />
      <ProductList
        featuredProducts={featuredProducts.filter(
          (item) =>
            slugify(item.productCategory ? item.productCategory : "") ===
            "may-lanh-am-tran"
        )}
        title={{
          name: "MÁY LẠNH ÂM TRẦN",
          link: "/products?category=may-lanh-am-tran",
        }}
        categories={[
          "Daikin",
          "Airwell",
          "Mitsubishi Heavy",
          "Panasonic",
          "General",
          "Sumikura",
          "Reetech",
          "LG",
          "HIKAWA",
        ]}
        bannerImage={
          "https://sieuthimaylanh.com/uploads/product/advertise/thumbs/may_lanh_treo_tuong_inverter-1600x400.jpg"
        }
      />
      <ProductList
        featuredProducts={featuredProducts.filter(
          (item) =>
            slugify(item.productCategory ? item.productCategory : "") ===
            "may-lanh-dung"
        )}
        title={{
          name: "MÁY LẠNH TỦ ĐỨNG",
          link: "/products?category=may-lanh-dung",
        }}
        categories={[
          "Casper",
          "Funiki",
          "Sumikura",
          "Midea",
          "Nagakawa",
          "Reetech",
          "Alaska",
          "Gree",
          "Airwell",
          "LG",
          "Akino",
          "Panasonic",
          "Daikin",
          "Mitsubishi Heavy",
          "Aqua",
          "Mitsubishi Electric",
          "Samsung",
          "HIKAWA",
        ]}
        bannerImage={
          "https://sieuthimaylanh.com/uploads/product/advertise/thumbs/may_lanh_treo_tuong_inverter-1600x400.jpg"
        }
      />
      <ProductList
        featuredProducts={featuredProducts.filter(
          (item) =>
            slugify(item.productCategory ? item.productCategory : "") ===
            "may-lanh-giau-tran---ong-gio"
        )}
        title={{
          name: "MÁY LẠNH GIẤU TRẦN ỐNG GIÓ",
          link: "/products?category=may-lanh-giau-tran-ong-gio",
        }}
        categories={[
          "Daikin",
          "Airwell",
          "Mitsubishi Heavy",
          "Panasonic",
          "General",
          "Sumikura",
          "Reetech",
          "LG",
          "HIKAWA",
        ]}
        bannerImage={
          "https://sieuthimaylanh.com/uploads/product/advertise/thumbs/may_lanh_treo_tuong_inverter-1600x400.jpg"
        }
      />
      <ProductList
        featuredProducts={featuredProducts.filter(
          (item) =>
            slugify(item.productCategory ? item.productCategory : "") ===
            "may-lanh-ap-tran"
        )}
        title={{
          name: "MÁY LẠNH ÁP TRẦN",
          link: "/products?category=may-lanh-ap-tran",
        }}
        categories={[
          "Reetech",
          "Daikin",
          "Nagakawa",
          "Midea",
          "Mitsubishi Heavy",
          "Panasonic",
          "Sumikura",
          "Toshiba",
          "Casper",
          "Mitsubishi Electric",
        ]}
        bannerImage={
          "https://sieuthimaylanh.com/uploads/product/advertise/thumbs/may_lanh_treo_tuong_inverter-1600x400.jpg"
        }
      />
      <Services handleOpenBooking={handleOpenBooking} />
      <StaffList />
      <MoreService handleOpenBooking={handleOpenBooking} />
      <PriseList />
      <CustomerReview />
      <Contact />
      <BookingModal
        open={openBooking}
        handleClose={handleCloseBooking}
        serviceName={serviceNameSelected}
      />
    </Box>
  );
};

export default Home;
